import React from 'react'
import './GetStarted.css'
const GetStarted = () => {
  return (
    <section className='get-wrap' id='GetStarted'>
        <div className='get-container'>
            <div className='get-inner-cont'>
                <span className='primaryText'>Get Started with Us </span>
                <span className='secondaryText'>Find your ideal residence quickly and easily 
                <br />with our super attractive price quotes.</span>
                <button className='button'>
                    <a href="mailto:ranjithsr004@gmail.com">Get Started</a>
                </button>
            </div>
        </div>
    </section>
  )
}

export default GetStarted